// extracted by mini-css-extract-plugin
export default {"wrapper":"app-layout_wrapper__FNyl3","content":"app-layout_content__KeV6m","menu":"app-layout_menu__nkG-s"};